import posthog from 'posthog-js';

// Example usage:

// useABTest(
//   'onboarding-ab-test',
//   (variant) => {
//     if (variant === 'tour-flow') {
//       window.location = '/sign-up/tour'
//     } else {
//       window.location = '/finish_sign_up'
//     }
//   },
//   '/finish_sign_up'
// );

export const useABTest = ({flagKey, handler, userId, defaultVariant = 'control'}) => {
  if (!userId) return

  // posthog recommends only calling 'identify' when the user is known,
  // since identify calls are idempotent with respect to browser session.
  // Unidentified users are given a posthog specific checksum,
  // which cannot be used to cross-reference Segment events
  posthog.identify(userId)
  return () => {
    try {
      const flagValue = posthog.getFeatureFlag(flagKey)
      handler(flagValue);
    } catch (error) {
      handler(defaultVariant);
    }
  };
};
